import daisyGirl from '../images/sketchbook/daisyGirl.jpg'
import fishGirl from '../images/sketchbook/fishGirl.jpg'
import floralGirl from '../images/sketchbook/floralGirl.jpg'
import frownyGirl from '../images/sketchbook/frownyGirl.jpg'
import sunflowerBoba from '../images/sketchbook/sunflowerBoba.jpg'
import teaMoon from '../images/sketchbook/teaMoon.jpg'
import wellWishes from '../images/sketchbook/wellWishes.jpg'
import autumnFlower from '../images/sketchbook/autumnFlower.jpg'
import contemplation from '../images/sketchbook/thonk.jpg'
import quarantinePortraits from '../images/sketchbook/covers/quarantine_portraits.png'
import rejection from '../images/sketchbook/covers/rejection.png'
import indigo from '../images/sketchbook/covers/indigo.png'

const drawings = {
    daisy_girl: {
        key: "daisy_girl",
        image: daisyGirl,
        title: "daisy.",
        date: "2020",
        pages: "0"
    },
    fish_girl: {
        key: "fish_girl",
        image: fishGirl,
        title: "river child.",
        date: "2020",
        pages: "0"
    },
    floral_girl: {
        key: "floral_girl",
        image: floralGirl,
        title: "botanical girl.",
        date: "2020",
        pages: "0"
    },
    frowny_girl: {
        key: "frowny_girl",
        image: frownyGirl,
        title: "moody.",
        date: "2020",
        pages: "0"
    },
    boba_girl: {
        key: "boba_girl",
        image: sunflowerBoba,
        title: "boba + sunlight.",
        date: "2020",
        pages: "0"
    },
    tea_moon: {
        key: "tea_moon",
        image: teaMoon,
        title: "evening reflection.",
        date: "2020",
        pages: "0"
    },
    quarantine_portraits: {
        key: "quarantine_portraits",
        image: quarantinePortraits,
        title: "Quarantine Portraits",
        date: "03/2021",
        pages: "https://www.behance.net/gallery/115589757/Pandemic-Portraits-a-quarantine-project"
    },
    autumnFlower: {
        key: "chrysanthemum",
        image: autumnFlower,
        title: "chrysanthemum",
        date: "2020",
        pages: "0"
    },
    contemplation: {
        key: "contemplation",
        image: contemplation,
        title: "contemplation",
        date: "2020",
        pages: "0"
    },
    rejection: {
        key: "rejection",
        image: rejection,
        title: "aboutrejection",
        date: "11/2021",
        pages: "https://itskun.online/journal/beingbelonging"
    },
    well_wishes: {
        key: "well_wishes",
        image: wellWishes,
        title: "well wishes.",
        date: "09/2021",
        pages: "0"
    },
    indigo: {
        key: "indigo",
        image: indigo,
        title: "indigo.",
        date: "12/2021",
        pages: "https://itskun.online/journal/indigo"
    },
    // template: {
    //     key:
    //     image:
    //     title:
    //     date:
    //     pages:
    // }
}

export default drawings;